module.exports = __webpack_public_path__ + "static/media/cloud-bottom.8913acb0.png";